@if (admissionData?.count! > 0) {
  <div id="divChart" class="chart-container">
    <canvas id="admissionReason"></canvas>
  </div>
}
